export const commonTranslations = {
  siteName: '88健康知識',
  siteSubtitle: '營養素成分介紹',
  navHome: '首頁',
  navHealth: '健康知識',
  navCategories: '分類',
  navAbout: '關於我們',
  searchPlaceholder: '搜尋營養素、文章...',
  searchButton: '搜尋',
  heroTitle: '你的身體由細胞構成, 它們需要營養,不是藥',
  heroSubtitle: '探索各類營養素的專業知識，科學補充，守護健康',
  heroCta: '瀏覽文章',
  latestArticles: '最新文章',
  popularNutrients: '熱門營養素',
  viewAll: '查看全部',
  readMore: '閱讀更多',
  publishedOn: '發布於',
  category: '分類',
  tags: '標籤',
  relatedArticles: '相關文章',
  aboutTitle: '關於我們',
  aboutCompany: '深圳市諾家健康有限公司',
  founderTitle: '創始人',
  founderName: '周團長',
  serviceScope: '服務範圍',
  importantNotice: '重要聲明',
  contactUs: '聯繫我們',
  contactEmail: '客服郵箱',
  wechatServiceAccount: '微信服務號',
  switchToSimplified: '簡體',
  switchToTraditional: '繁體',
  language: '語言',
  footerCompany: '深圳市諾家健康有限公司',
  footerAddress: '深圳市龍華區龍華街道松和社區匯食街一巷10號晨源商務大廈1206, 郵編: 518109',
  icpRecord: '粵ICP備2025408921號-3',
  allRightsReserved: '版權所有',
  noMedicalAdvice: '本網站不提供醫療診斷、疾病治療、在線問診或藥品銷售服務。如有健康問題，請及時諮詢專業醫療機構。本網站分享的健康知識、營養建議與產品資訊僅供參考，不能替代專業醫生的診斷與治療。',
  companyIntro: '88健康知識網由深圳市諾家健康有限公司運營，專注於分享各類營養素成分的專業知識。我們致力於以科學、準確、易懂的方式，幫助大眾了解身體健康所需的各類營養成分。',
  homeMissionQuote: '「學習有效的健康知識，才不會在重大疾病來臨時，只能把錢送給醫院，命交給醫生，然後聽天由命，期待奇蹟發生。」',
  homeMissionDesc: '88健康知識網致力於分享各類營養素成分的專業知識，以科學、準確、易懂的方式，幫助大眾了解身體健康所需的各類營養成分。本站所有內容僅供健康知識參考，不能替代專業醫生的診斷與治療。',
  aboutServiceInfo: '企業信息展示',
  aboutServiceInfoDesc: '公司介紹、專業資質與團隊背景',
  aboutServiceHealth: '健康知識分享',
  aboutServiceHealthDesc: '營養素成分介紹、膳食補充劑資訊',
  aboutServiceContact: '客服聯繫',
  aboutServiceContactDesc: '產品諮詢、營養建議與售後服務',
  aboutServiceShipping: '配送說明',
  aboutServiceShippingDesc: '兩岸發貨政策、物流追踪與配送範圍',
  vitaminCategory: '維生素類',
  mineralCategory: '礦物質類',
  aminoAcidCategory: '氨基酸類',
  probioticCategory: '益生菌類',
  fattyAcidCategory: '脂肪酸類',
  antioxidantCategory: '抗氧化類',
  herbCategory: '草本植萃類',
  otherCategory: '其他營養素',
  articleCount: '篇文章',
  learnMore: '了解更多',
  scrollDown: '向下滾動',
  backToTop: '回到頂部',
  notFound: '頁面未找到',
  notFoundDesc: '您訪問的頁面不存在，請返回首頁繼續瀏覽。',
  backToHome: '返回首頁',
  searchResults: '搜尋結果',
  noSearchResults: '沒有找到相關文章',
  tryOtherKeywords: '請嘗試其他關鍵詞',
  loadError: '數據載入失敗，請檢查網絡連接後重試。',
  retry: '重新載入',
  // Article type
  articleTypeOriginal: '原創文章',
  articleTypeEmbedded: '引用嵌入',
  articleTypeLabel: '文章類型',
  sourceUrl: '來源網址',
  sourceUrlPlaceholder: '請輸入要引用的文章網址 https://...',
  sourceName: '來源名稱',
  sourceNamePlaceholder: '例如：維基百科、健康雜誌等',
  sourceThanksText: '感謝語',
  sourceThanksTextDefault: '特別感謝 [來源名稱] 提供本文的寶貴內容，本頁面僅為引用展示，版權歸原作者所有。',
  fetchContent: '抓取內容',
  fetchingContent: '正在抓取內容...',
  fetchSuccess: '內容抓取成功！',
  fetchFail: '內容抓取失敗，請檢查網址是否正確或手動輸入內容',
  fetchingRequirement: '請先輸入來源網址',
  sourceAttribution: '文章來源',
  sourceOpenOriginal: '查看原文',
  originalContent: '原創內容',
  urlCheckStatus: '連結狀態',
  urlAlive: '正常',
  urlDead: '已失效',
  // AI Image Generation
  aiGenImage: 'AI 生圖',
  aiGenImageDesc: '輸入中文描述，AI 自動生成配圖',
  aiGenPromptPlaceholder: '用中文描述你想要的圖片，例如：一瓶維生素C補充劑放在純白背景上，旁邊點綴著新鮮的橙子和檸檬切片，柔和自然光，產品攝影風格',
  aiGenGenerating: '生成中...',
  aiGenGenerate: '生成圖片',
  aiGenCancel: '取消',
  aiGenHint: '描述越詳細效果越好。圖片將自動填入上方預覽區。',
};

export default commonTranslations;